angular.module('rxrefills').factory('PrescriptionService',
    ['PatientSettingsService', 'RxRefillRepository', '$q',
        function (PatientSettingsService, RxRefillRepository, $q) {
            'use strict';

            var rxRefills,
                pharmacies,
                selectedMed,
                prescriptionsServiceUserId;

                
            var medFilters = [
                { Id: 1, Days: -1, Name: 'All' },
                { Id: 2, Days: 30, Name: 'Current' }
            ];

            function getDateDiff(date) {
                date = moment(date).startOf('d');
                var utc1 = moment().startOf('d');

                return date.diff(utc1, 'd');
            }

            function dateFilter(date, validDays) {
                //return true if there is no date since it's assumed the medication is ongoing
                //active < 0 means they are showing all Prescriptions
                if (date && validDays >= 0) {
                    var diff = getDateDiff(date);
                    return diff >= -1 * validDays;
                }
                return true;
            }    
            
            function saveRxRefills(rxRefillsToSave) {
                rxRefills = rxRefillsToSave;
                return rxRefills;
            }

            function getRxRefills(patientId, expiring) {
                expiring = expiring || false;
                if (patientId !== prescriptionsServiceUserId) {
                    resetService(patientId);
                }
                if (!rxRefills) {
                    return RxRefillRepository.getRxRefills(patientId, expiring)
                        .then(function (data) {
                            rxRefills = data;
                            return rxRefills;
                        });
                } else {
                    return $q.when(rxRefills);
                }
            }

            function putRxRefills(rxRefillRequest) {
                return RxRefillRepository.putRxRefills(rxRefillRequest.PatientId, rxRefillRequest)
                    .then(function (data) {
                        rxRefills = data;
                        return rxRefills;
                    });
            }

            function getPharmacies(patientId) {
                if (patientId !== prescriptionsServiceUserId) {
                    resetService(patientId);
                }
                if (!pharmacies) {
                    return RxRefillRepository.getPharmacies(patientId)
                        .then(function (data) {
                            pharmacies = data;
                            return pharmacies;
                        });
                } else {
                    return $q.when(pharmacies);
                }
            }

            function setSelectedMedId(med) {
                selectedMed = med;
            }

            function clearSelectedMedId() {
                selectedMed = null;
            }

            function getSelectedMedId() {
                return selectedMed;
            }

            function resetService(patientId) {
                clearAll();
                setPrescriptionServiceUserId(patientId);
            }

            function clearAll(){
                rxRefills = null;
                pharmacies = null;
                selectedMed = null;
            }

            function setPrescriptionServiceUserId(patientId){
                prescriptionsServiceUserId = patientId;
            }

            function auditMedicationsLogging(requestReportDto) {
                return RxRefillRepository.postMedicationsAudit(requestReportDto);
            }
            return {
                medFilters: medFilters,
                saveRxRefills: saveRxRefills,
                getRxRefills: getRxRefills,
                dateFilter : dateFilter,
                putRxRefills: putRxRefills,
                getPharmacies: getPharmacies,
                setSelectedMedId: setSelectedMedId,
                getSelectedMedId: getSelectedMedId,
                clearSelectedMedId: clearSelectedMedId,
                auditMedicationsLogging : auditMedicationsLogging
            };
        }]);
